import React from "react";
export default function Gallery() {
    return (
 <section id="gallery" className="content-section light gallery-section">
        <div className="container">
            <h2 className="display-5 fw-bold text-center mb-5 gallery-title">Hotel Gallery</h2>
            <p className="lead text-center mb-5 gallery-subtitle">Take a visual journey through our luxurious accommodations, stunning views, and world-class facilities</p>

            {/* Gallery Filters */}
            <div className="text-center gallery-filter-enhanced">
                <button type="button" className="btn active" data-filter="all">All</button>
                <button type="button" className="btn" data-filter="rooms">Rooms</button>
                <button type="button" className="btn" data-filter="views">Views</button>
                <button type="button" className="btn" data-filter="facilities">Facilities</button>
                <button type="button" className="btn" data-filter="nature">Nature</button>
            </div>

            {/* Gallery Carousel */}
            <div className="gallery-carousel-container mb-5">

                <div id="galleryCarousel" className="carousel slide gallery-carousel-enhanced" data-bs-ride="carousel" data-bs-interval="4000" data-bs-pause="hover">
                    <div className="carousel-indicators carousel-indicators-enhanced">
                        <button type="button" data-bs-target="#galleryCarousel" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                        <button type="button" data-bs-target="#galleryCarousel" data-bs-slide-to="1" aria-label="Slide 2"></button>
                        <button type="button" data-bs-target="#galleryCarousel" data-bs-slide-to="2" aria-label="Slide 3"></button>
                        <button type="button" data-bs-target="#galleryCarousel" data-bs-slide-to="3" aria-label="Slide 4"></button>
                        <button type="button" data-bs-target="#galleryCarousel" data-bs-slide-to="4" aria-label="Slide 5"></button>
                        <button type="button" data-bs-target="#galleryCarousel" data-bs-slide-to="5" aria-label="Slide 6"></button>
                        <button type="button" data-bs-target="#galleryCarousel" data-bs-slide-to="6" aria-label="Slide 7"></button>
                        <button type="button" data-bs-target="#galleryCarousel" data-bs-slide-to="7" aria-label="Slide 8"></button>
                        <button type="button" data-bs-target="#galleryCarousel" data-bs-slide-to="8" aria-label="Slide 9"></button>
                        <button type="button" data-bs-target="#galleryCarousel" data-bs-slide-to="9" aria-label="Slide 10"></button>
                    </div>
                    
                    <div className="carousel-inner">
                        <div className="carousel-item active" data-category="rooms">
                            <div className="gallery-carousel-item-enhanced">
                                <img src="/ImagesHotelGallery/43.jpg" 
                                     alt="Hotel Gallery Image 1" className="img-fluid w-100"/>
                                <div className="carousel-caption-enhanced">
                                    <h5>Hotel Gallery</h5>
                                    <p>Luxurious accommodations and spaces</p>
                                </div>
                            </div>
                        </div>
                        
                        <div className="carousel-item" data-category="rooms">
                            <div className="gallery-carousel-item-enhanced">
                                <img src="/ImagesHotelGallery/47.jpg" 
                                     alt="Hotel Gallery Image 2" className="img-fluid w-100"/>
                                <div className="carousel-caption-enhanced">
                                    <h5>Hotel Gallery</h5>
                                    <p>Elegant room designs and comfort</p>
                                </div>
                            </div>
                        </div>
                        
                        <div className="carousel-item" data-category="facilities">
                            <div className="gallery-carousel-item-enhanced">
                                <img src="/ImagesHotelGallery/28.jpg" 
                                     alt="Hotel Gallery Image 3" className="img-fluid w-100"/>
                                <div className="carousel-caption-enhanced">
                                    <h5>Hotel Gallery</h5>
                                    <p>Stunning hotel interiors and design</p>
                                </div>
                            </div>
                        </div>
                        
                        <div className="carousel-item" data-category="facilities">
                            <div className="gallery-carousel-item-enhanced">
                                <img src="/ImagesHotelGallery/27.jpg" 
                                     alt="Hotel Gallery Image 4" className="img-fluid w-100"/>
                                <div className="carousel-caption-enhanced">
                                    <h5>Hotel Gallery</h5>
                                    <p>Beautiful hotel facilities and amenities</p>
                                </div>
                            </div>
                        </div>
                        
                        <div className="carousel-item" data-category="views">
                            <div className="gallery-carousel-item-enhanced">
                                <img src="/ImagesHotelGallery/62.jpg" 
                                     alt="Hotel Gallery Image 5" className="img-fluid w-100"/>
                                <div className="carousel-caption-enhanced">
                                    <h5>Hotel Gallery</h5>
                                    <p>Breathtaking views and surroundings</p>
                                </div>
                            </div>
                        </div>
                        
                        <div className="carousel-item" data-category="views">
                            <div className="gallery-carousel-item-enhanced">
                                <img src="/ImagesHotelGallery/65.jpg" 
                                     alt="Hotel Gallery Image 6" className="img-fluid w-100"/>
                                <div className="carousel-caption-enhanced">
                                    <h5>Hotel Gallery</h5>
                                    <p>Scenic landscapes and natural beauty</p>
                                </div>
                            </div>
                        </div>
                        
                        <div className="carousel-item" data-category="nature">
                            <div className="gallery-carousel-item-enhanced">
                                <img src="/ImagesHotelGallery/71.jpg" 
                                     alt="Hotel Gallery Image 7" className="img-fluid w-100"/>
                                <div className="carousel-caption-enhanced">
                                    <h5>Hotel Gallery</h5>
                                    <p>Nature-inspired design and outdoor spaces</p>
                                </div>
                            </div>
                        </div>
                        
                        <div className="carousel-item" data-category="nature">
                            <div className="gallery-carousel-item-enhanced">
                                <img src="/ImagesHotelGallery/74.jpg" 
                                     alt="Hotel Gallery Image 8" className="img-fluid w-100"/>
                                <div className="carousel-caption-enhanced">
                                    <h5>Hotel Gallery</h5>
                                    <p>Peaceful natural environment and gardens</p>
                                </div>
                            </div>
                        </div>
                        
                        <div className="carousel-item" data-category="facilities">
                            <div className="gallery-carousel-item-enhanced">
                                <img src="/ImagesHotelGallery/5.jpg" 
                                     alt="Hotel Gallery Image 9" className="img-fluid w-100"/>
                                <div className="carousel-caption-enhanced">
                                    <h5>Hotel Gallery</h5>
                                    <p>Modern facilities and elegant interiors</p>
                                </div>
                            </div>
                        </div>
                        
                        <div className="carousel-item" data-category="facilities">
                            <div className="gallery-carousel-item-enhanced">
                                <img src="/ImagesHotelGallery/2.jpeg" 
                                     alt="Hotel Gallery Image 11" className="img-fluid w-100" style={{objectFit: 'contain', backgroundColor: '#f8f9fa'}}/>
                                <div className="carousel-caption-enhanced">
                                    <h5>Hotel Gallery</h5>
                                    <p>Modern facilities and amenities</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <button className="carousel-control-prev carousel-control-enhanced carousel-control-prev-enhanced" type="button" data-bs-target="#galleryCarousel" data-bs-slide="prev">
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Previous</span>
                    </button>
                    <button className="carousel-control-next carousel-control-enhanced carousel-control-next-enhanced" type="button" data-bs-target="#galleryCarousel" data-bs-slide="next">
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Next</span>
                    </button>
                </div>
            </div>

            <div className="text-center mt-5">
                <a href="#contact" className="btn gallery-cta-button btn-lg">Book Your Stay & See More</a>
            </div>
        </div>
    </section>
    )
}